import styled, {css} from "styled-components";

const ContainerProductos = styled.div `
    padding: 10px 5px;
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 1;
    flex-basis: 200px;
    justify-content: center;
    gap: 10px;
    margin-top: 10px;

    button {
        cursor: pointer;
        transition: transform .3s;
    }

    ${props => props.toldos && css`
        flex-basis: 320px;
        
    }
    `}
`;
export default ContainerProductos;